// extracted by mini-css-extract-plugin
export default {"utility":"Utility_utility__HKx3m","heading":"Utility_heading__hDMYa","accordion":"Utility_accordion__OS3HN"};